import { put, takeLatest } from 'redux-saga/effects';
import { m365Actions } from './slice';
import { Notification } from 'zComponents/atoms';

export function* verifyConnection() {
	const superFetchModule = yield import('library/helpers/superFetch');
	const superFetch = superFetchModule.default;
	try {
		const res = yield superFetch.post(`/m365/verify`);
		if (res.statusCode === 200) {
			const mailbox = res.data?.mailbox;
			Notification('success', `Connection verified${mailbox ? ` — read ${mailbox}` : ''}.`);
			yield put(m365Actions.verifyConnectionSuccess());
		} else {
			throw new Error(res.error);
		}
	} catch (error) {
		Notification('error', error.message || 'Failed to verify the Microsoft 365 connection.');
		yield put(m365Actions.verifyConnectionError(error.message));
	}
}

export default function* m365Sagas() {
	yield takeLatest(m365Actions.verifyConnection, verifyConnection);
}
